var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33858 5.45533L9.29616 9.88735C9.51825 10.2865 9.57453 10.7569 9.45283 11.1971C9.33114 11.6373 9.04124 12.0121 8.64569 12.2404C8.25015 12.4688 7.78067 12.5325 7.33858 12.4178C6.89648 12.3031 6.51722 12.0191 6.28263 11.6272L3.09929 5.45533C2.90002 5.11966 2.76936 4.74777 2.71489 4.36123C2.66042 3.97468 2.68322 3.58117 2.78196 3.20351C2.8807 2.82584 3.05343 2.47153 3.29013 2.16111C3.52683 1.8507 3.82278 1.59036 4.16085 1.39518C4.49891 1.19999 4.87235 1.07386 5.25953 1.02408C5.64671 0.974302 6.03991 1.00187 6.41635 1.10519C6.79279 1.20851 7.14498 1.38552 7.4525 1.62597C7.76002 1.86641 8.01676 2.16551 8.20782 2.50591L11.4138 8.72837C11.6955 9.2003 11.8805 9.72352 11.9582 10.2676C12.0358 10.8117 12.0045 11.3657 11.8661 11.8976C11.7277 12.4295 11.485 12.9286 11.152 13.3658C10.819 13.803 10.4024 14.1697 9.92646 14.4445C9.45051 14.7193 8.92467 14.8967 8.37953 14.9665C7.83439 15.0362 7.28082 14.9969 6.751 14.8508C6.22118 14.7048 5.72569 14.4548 5.29333 14.1155C4.86097 13.7763 4.50037 13.3544 4.23249 12.8745L2.78196 9.88735",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachments);
export default __webpack_public_path__ + "static/media/attachments.dbaae2899d1463cfc99bfba71eb813d9.svg";
export { ForwardRef as ReactComponent };